import React, { useState } from 'react';
import { DEFAULT_DOOR_STYLE } from './Door3D.jsx';
import './doorStyleBox.scss';

// انواع درِ قابل‌انتخاب — هر نوع، در Door3D.jsx نحوه‌ی بازشدنِ مخصوصِ خودش را هم دارد (چرخشی/تاشو/لغزنده)
const DOOR_TYPES = [
  { value: 'single', label: 'یک‌تیکه' },
  { value: 'double', label: 'دوتیکه' },
  { value: 'glassModern', label: 'مدرن و شیشه‌ای' },
  { value: 'french', label: 'فرانسوی (قابی)' },
  { value: 'classic', label: 'قدیمی (رنگ و جنس)' },
  { value: 'folding', label: 'تاشو (اکاردئونی)' },
  { value: 'sliding', label: 'کشویی تک‌لنگه' },
  { value: 'doubleSliding', label: 'کشویی دولنگه' },
  { value: 'barn', label: 'کشویی ریلی (بارن)' },
];

const MAIN_COLOR_PRESETS = ['#8a5a3b', '#5c4433', '#c9a876', '#ffffff', '#2f333a', '#7a1f1f'];
const ACCENT_COLOR_PRESETS = ['#3a3a3a', '#c9a227', '#8a8177', '#d8c48a', '#5c5348', '#ffffff'];

// جنسِ سطحِ اصلیِ در — 'paint' یعنی رنگِ واقعی (بافتِ سطحِ رنگ‌شده زیرِ رنگِ انتخابی)؛ بقیه، عکسِ واقعیِ PBR هستند (دقیقاً همان
// FRAME_MATERIAL_TYPES در windowStyleBox.jsx)
const DOOR_MATERIAL_TYPES = [
  { value: 'paint', label: 'رنگ' },
  { value: 'woodPine', label: 'چوبِ روشن ✦' },
  { value: 'woodDark', label: 'چوبِ تیره ✦' },
  { value: 'metalBrushed', label: 'فلزِ واقعی ✦' },
];
// جنس‌هایی که عکسِ واقعی‌اند و رنگِ انتخابی رویشان «ضرب» می‌شود
const PHOTO_MATERIALS = ['woodPine', 'woodDark', 'metalBrushed'];

const TABS = [
  { id: 'type', label: 'نوع' },
  { id: 'material', label: 'رنگ و جنس' },
  { id: 'size', label: 'ابعاد' },
];

const WIDTH_MIN_CM = 60;
const WIDTH_MAX_CM = 200;
const HEIGHT_MIN_CM = 180;
// حداکثرِ پیش‌فرض، برای وقتی که wallHeightCm در دسترس نیست — در عمل همیشه ارتفاعِ سقف (wallHeightCm)
// جایگزینش می‌شود تا کاربر بتواند در را «تا سقف» بلند کند
const HEIGHT_MAX_CM_FALLBACK = 280;

function ColorField({ label, value, presets, onChange }) {
  return (
    <div className="door-style-box__field">
      {label && <span className="door-style-box__label">{label}</span>}
      <div className="door-style-box__swatches">
        {presets.map((c) => (
          <button
            key={c}
            type="button"
            className={`door-style-box__swatch ${value === c ? 'is-active' : ''}`}
            style={{ background: c }}
            onClick={() => onChange(c)}
          />
        ))}
        <input
          type="color"
          className="door-style-box__custom-color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}

// پنلِ ادیتِ یک در در حالت سه‌بعدی — همان الگوی WallStyleBox (بشقاب ثابتِ پایین صفحه، تب‌بندی‌شده)
// ولی برای در: نوع (یک‌تیکه/دوتیکه/مدرن‌شیشه‌ای/قدیمی)، رنگ و جنس (رنگ اصلی + رنگِ دستگیره/قاب)، و
// ابعاد (عرض/ارتفاع، سانتی‌متر — که مستقیماً روی اندازه‌ی بازشوی برش‌خورده از دیوار هم اثر می‌گذارد)
function DoorStyleBox({
  style,
  defaultWidthCm,
  wallHeightCm,
  onChangeType,
  onChangeColor,
  onChangeAccent,
  onChangeSize,
  onChangeMaterial,
  // جهتِ بازشدن و سمتِ لولا (روی خودِ در، نه style)
  facing,
  hinge,
  onChangeFacing,
  onFlipHinge,
  onClose,
}) {
  const [activeTab, setActiveTab] = useState('type');
  const s = style || DEFAULT_DOOR_STYLE;
  const width = s.widthCm || defaultWidthCm || 80;
  const height = s.heightCm || 210;
  // ارتفاعِ در حالا می‌تواند «تا سقف» بالا برود — سقفِ اسلایدر همان ارتفاعِ دیوار است، نه یک عددِ ثابت
  const heightMaxCm = wallHeightCm || HEIGHT_MAX_CM_FALLBACK;
  const isPhoto = PHOTO_MATERIALS.includes(s.material);

  return (
    <div className="door-style-box">
      <div className="door-style-box__header">
        <span>تنظیمات این در</span>
        <button type="button" onClick={onClose}>
          بستن
        </button>
      </div>

      <div className="door-style-box__tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={activeTab === tab.id ? 'is-active' : ''}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'type' && (
        <div className="door-style-box__panel">
          <div className="door-style-box__pills door-style-box__pills--wrap">
            {DOOR_TYPES.map((t) => (
              <button
                key={t.value}
                type="button"
                className={s.type === t.value ? 'is-active' : ''}
                onClick={() => onChangeType(t.value)}
              >
                {t.label}
              </button>
            ))}
          </div>
          <p className="door-style-box__hint">
            {s.type === 'double'
              ? 'دو لنگه از دو طرف، هم‌زمان و متقارن، روی لولا باز می‌شوند.'
              : s.type === 'glassModern'
              ? 'قابِ نازک + یک شیشه‌ی بزرگِ نیمه‌شفاف، روی لولا باز می‌شود — حسِ مدرن.'
              : s.type === 'french'
              ? 'قابِ چوبی‌رنگ با چند شیشه‌ی کوچک به‌جای یکی بزرگ، روی لولا باز می‌شود — حسِ درهای فرانسویِ کلاسیک.'
              : s.type === 'classic'
              ? 'دو پنلِ برجسته و دستگیره‌ی برنجی، روی لولا باز می‌شود — حسِ قدیمی.'
              : s.type === 'folding'
              ? 'دو نیم‌پنل که با یک مفصلِ وسط به‌هم وصل‌اند و مثلِ اکاردئون جمع می‌شوند — مناسبِ کمدها یا ورودی‌های کم‌جا.'
              : s.type === 'sliding'
              ? 'ظاهرِ شیشه‌ای مثلِ درِ مدرن، ولی به‌جای چرخش روی لولا، کنار می‌لغزد — مناسبِ بالکن یا ورودی‌های مدرن.'
              : s.type === 'doubleSliding'
              ? 'دو لنگه از وسط، هم‌زمان به دو طرفِ مخالف می‌لغزند — مناسبِ ورودی‌های بزرگ یا فضاهای باز.'
              : s.type === 'barn'
              ? 'تخته‌های چوبیِ عمودی با یک ریلِ فلزیِ بالای در؛ مثلِ «کشویی»، کنار می‌لغزد نه این‌که باز شود.'
              : 'یک لنگه‌ی ساده، از یک لبه لولا می‌خورد.'}
          </p>
        </div>
      )}

      {activeTab === 'material' && (
        <div className="door-style-box__panel">
          <div className="door-style-box__field">
            <span className="door-style-box__label">جنسِ سطح</span>
            <div className="door-style-box__pills">
              {DOOR_MATERIAL_TYPES.map((m) => (
                <button
                  key={m.value}
                  type="button"
                  className={(s.material || 'paint') === m.value ? 'is-active' : ''}
                  onClick={() => onChangeMaterial(m.value)}
                >
                  {m.label}
                </button>
              ))}
            </div>
          </div>
          {/* نکته: برای «مدرن و شیشه‌ای»/«کشویی»، قابِ در واقعاً از رنگِ فرعی (accent) ساخته می‌شود، نه
              رنگِ اصلی — برای همین این‌جا برچسب‌ها بر همین اساس عوض می‌شوند، وگرنه کاربر رنگِ اصلی را
              عوض می‌کرد ولی هیچ اثری روی قابِ در نمی‌دید */}
          {!(s.type === 'glassModern' || s.type === 'sliding') && (
            <ColorField
              label={
                isPhoto
                  ? 'رنگ (روی عکسِ واقعی اعمال می‌شود)'
                  : s.type === 'french'
                  ? 'رنگ قابِ چوبی'
                  : s.type === 'barn'
                  ? 'رنگ تخته‌ها'
                  : 'رنگ اصلی'
              }
              value={s.color || '#8a5a3b'}
              presets={MAIN_COLOR_PRESETS}
              onChange={onChangeColor}
            />
          )}
          {isPhoto && (
            <p className="door-style-box__hint">
              این جنس یک عکسِ واقعیِ {s.material === 'metalBrushed' ? 'فلز' : 'چوب'} است؛ جزئیات از خودِ عکس می‌آید.
              سفید = رنگِ طبیعیِ خودِ عکس؛ رنگ‌های تیره‌تر، مثلِ رنگ‌کاری/ترکیب، آن را تیره‌تر می‌کنند.
            </p>
          )}
          <ColorField
            label={
              s.type === 'glassModern' || s.type === 'sliding'
                ? isPhoto
                  ? 'رنگ قاب (روی عکسِ واقعی اعمال می‌شود)'
                  : 'رنگ قاب'
                : s.type === 'classic'
                ? 'رنگ پنل/دستگیره'
                : s.type === 'barn'
                ? 'رنگ درزها/دستگیره'
                : 'رنگ دستگیره'
            }
            value={s.accent || '#3a3a3a'}
            presets={ACCENT_COLOR_PRESETS}
            onChange={onChangeAccent}
          />
        </div>
      )}

      {activeTab === 'size' && (
        <div className="door-style-box__panel">
          {onChangeFacing && (
            <div className="door-style-box__field">
              <span className="door-style-box__label">جهتِ بازشدن</span>
              <div className="door-style-box__pills">
                <button type="button" className={(facing || 'out') === 'out' ? 'is-active' : ''} onClick={() => onChangeFacing('out')}>
                  رو به بیرون
                </button>
                <button type="button" className={facing === 'in' ? 'is-active' : ''} onClick={() => onChangeFacing('in')}>
                  رو به داخل
                </button>
                {onFlipHinge && (
                  <button type="button" className={hinge === 'end' ? 'is-active' : ''} onClick={onFlipHinge}>
                    ⇄ لولا طرفِ دیگر
                  </button>
                )}
              </div>
            </div>
          )}
          <div className="door-style-box__field">
            <span className="door-style-box__label">عرض در: {width} سانتی‌متر</span>
            <input
              type="range"
              min={WIDTH_MIN_CM}
              max={WIDTH_MAX_CM}
              step={5}
              value={width}
              onChange={(e) => onChangeSize({ widthCm: Number(e.target.value) })}
              className="door-style-box__slider"
            />
          </div>
          <div className="door-style-box__field">
            <span className="door-style-box__label">ارتفاع در: {height} سانتی‌متر</span>
            <input
              type="range"
              min={HEIGHT_MIN_CM}
              max={heightMaxCm}
              step={5}
              value={height}
              onChange={(e) => onChangeSize({ heightCm: Number(e.target.value) })}
              className="door-style-box__slider"
            />
          </div>
          <p className="door-style-box__hint">
            تغییرِ عرض یا ارتفاع، اندازه‌ی بازشوی برش‌خورده از دیوار را هم به‌روز می‌کند. ارتفاع را می‌توان تا سقف
            ({heightMaxCm} سانتی‌متر) بالا برد.
          </p>
        </div>
      )}
    </div>
  );
}

export default DoorStyleBox;